import {Component} from "react";
import {values} from "mobx";
import VerticalBlock from "../blocks/TerracedGridTheme/VerticalBlock";

import classNames from "classnames";
import styles from "./styles/StaticGrid.module.scss";
import {StoreContext} from "../../stores/StoreLoader";
import {observer} from "mobx-react";

const pageBodyClassName = classNames({
    [styles.pageBody]: true,
});

type TerracedGridProps = {
    blocks: AnyBlockObj[],
}

@observer
export class TerracedGrid extends Component<TerracedGridProps> {
    static contextType = StoreContext;

    constructor(props: TerracedGridProps, context) {
        super(props);

        context.gridStore.setBlocks(props.blocks);
    }

    render() {
        return <main className={pageBodyClassName} role="main" id={'main'}>
            {values(this.context.gridStore.blocks)
                .filter(blockObj => blockObj.type !== "hero")
                .map((blockObj, i) => {
                    return <VerticalBlock
                        key={blockObj.id}
                        blockObj={blockObj}
                    />
                })}
        </main>
    }
}